// Copyright (c) 2017 Deere & Company

import TcsmApproveDenyModal from '../state/tcsm-approve-deny-modal';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const openModal = (state, action) =>
    TcsmApproveDenyModal.update(state, {
        actionToTake: {
            $set: action.actionToTake
        },
        isVisible: {
            $set: true
        }
    });

const closeModal = state =>
    TcsmApproveDenyModal.update(state, {
        $set: getDefaultState().pipCodeRequestModal
    });

export default (state = getDefaultState().pipCodeRequestModal, action) => {

    const actionTypes = {
        [actions.CLOSE_TCSM_PIP_CODE_REQUEST_MODAL]: closeModal,
        [actions.OPEN_TCSM_PIP_CODE_REQUEST_MODAL]: openModal
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/wip/reducers/pip-code-request-modal.js